import { SuccessViewCheckmark } from '../components/success-view/SuccessViewCheckmark'
import { SuccessViewContent } from '../components/success-view/SuccessViewContent'
import { SuccessViewProceedButton } from '../components/success-view/SuccessViewProceedButton'
import { SuccessViewSummaryPanel } from '../components/success-view/SuccessViewSummaryPanel'
import { SuccessViewTokenRow } from '../components/success-view/SuccessViewTokenRow'
import { objectiveTypeToVerb } from '../logic/title'
import { TokenWithValue } from '@/domain/common/types'
import { ObjectiveType } from '@/features/actions/logic/types'

export interface SuccessViewProps {
  objectiveType: ObjectiveType
  tokenWithValue: TokenWithValue
  onProceed: () => void
  proceedText: string
  className?: string
  successViewProceedButtonDataTestId?: string
}
export function SuccessView({
  objectiveType,
  tokenWithValue,
  onProceed,
  proceedText,
  className,
  successViewProceedButtonDataTestId,
}: SuccessViewProps) {
  const { token, value } = tokenWithValue

  return (
    <SuccessViewContent className={className}>
      <SuccessViewCheckmark />
      <SuccessViewSummaryPanel title={objectiveTypeToVerb[objectiveType]}>
        <SuccessViewTokenRow token={token} amount={value} />
      </SuccessViewSummaryPanel>
      <SuccessViewProceedButton onProceed={onProceed} dataTestId={successViewProceedButtonDataTestId}>
        {proceedText}
      </SuccessViewProceedButton>
    </SuccessViewContent>
  )
}
